<div class="container">
  <button
    class="btn-delete button-gray {{ !count && 'disable-btn' }}"
    [disabled]="!(count > 0)"
    (click)="viewDeleteModel()"
  >
    <va-icon size="small" name="trash" class="fa-sm"></va-icon>
    Delete
  </button>
  <div class="button-container">
    <div class="show-filter">
      <span class="show-filter-text">Show Filter</span>
      <nz-switch nzSize="small" [(ngModel)]="isFilterEnable"></nz-switch>
    </div>
    <button
      nz-button
      nzSize="small"
      nzType="primary"
      class="button-separator embargo-button"
      (click)="addEmbargoOverride()"
    >
      <va-icon size="small" name="plus" class="fa-sm"></va-icon>
      Add Embargo Override
    </button>
    <button
      nz-button
      nzSize="small"
      nzType="primary"
      class="button-separator embargo-button"
      (click)="showDefaultEmbargo()"
    >
      <va-icon size="small" name="eye" class="fa-sm"></va-icon>
      View Embargo Default
    </button>
    <button class="button-separator button-gray" (click)="showExportEmbargo()">
      <va-icon size="small" name="file-excel" class="fa-sm"></va-icon>
      Export
    </button>
    <div class="reload" title="Reload Grid" (click)="onReloadTrigger()">
      <va-icon size="small" name="sync" class="reload-icon"></va-icon>
    </div>
  </div>
  <div class="grid-container">
    <app-embargo-management-grid
      (setDefaultEmbargo)="setDefaultEmbargo($event)"
      (editEmbargoOverrideDetails)="editEmbargoOverride($event)"
      [fetchGrid]="fetchGrid"
      (changeKeyword)="changeKeyword($event)"
      (changeSortObj)="changeSortObj($event)"
      (countChanged)="countChanged($event)"
      (deleteCount)="deleteCount($event)"
      [isFilterEnable]="isFilterEnable"
      [reloadTrigger]="reloadTrigger"
    >
    </app-embargo-management-grid>
  </div>
</div>

<!-- Embargo Default Modal -->
<nz-modal
  [(nzVisible)]="isEmbargoDefaultVisible"
  nzTitle="Embargo Defaults"
  [nzContent]="modalContent"
  [nzFooter]="null"
  [nzWidth]="450"
  (nzOnCancel)="handleCancelForDefaultEmbargo()"
>
  <ng-template #modalContent>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="10">Model Data Usage</div>
      <div nz-col nzSpan="14">
        <input
          nz-input
          [ngModel]="defaultEmbargo.model_data"
          [disabled]="true"
        />
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="10">Model Download</div>
      <div nz-col nzSpan="14">
        <input
          nz-input
          [ngModel]="defaultEmbargo.model_download"
          [disabled]="true"
        />
      </div>
    </div>
    <div nz-row class="row-holder">
      <div nz-col nzSpan="10">Research Download</div>
      <div nz-col nzSpan="14">
        <input
          nz-input
          [ngModel]="defaultEmbargo.research_download"
          [disabled]="true"
        />
      </div>
    </div>
  </ng-template>
</nz-modal>

<!-- Embargo Override Modal -->
<div class="embargo-override-container">
  <app-embargo-override-modal
    [showModal]="isEmbargoOverrideVisible"
    (closeModal)="closeModalEmbargoOverride($event)"
    [editEmbargoOverrideData]="editEmbargoOverrideData"
    [embargoOverrideType]="embargoOverrideType"
    (showWarning)="showWarningModal($event)"
    (triggerFetchGrid)="triggerFetchGrid()"
  >
  </app-embargo-override-modal>
</div>

<!-- Embargo export modal -->
<div class="embargo-export-container">
  <app-embargo-export-modal
    [showModal]="isEmbargoExportVisible"
    (closeModal)="closeModalEmbargoExport($event)"
    [brokerSearchKeyword]="brokerKeyword"
    [buySideSearchKeyword]="buySideKeyword"
    [sortOrder]="sortOrder"
    [sortBy]="sortBy"
  >
  </app-embargo-export-modal>

  <!-- Embargo delete Modal -->
  <div class="embargo-delete-container">
    <app-embargo-delete-modal
      [showModal]="isDeleteModelVisible"
      (closeModal)="closeDeleteModal($event)"
      [count]="count"
      [deleteData]="deleteData"
      (triggerFetchGridAfterDelete)="triggerFetchGridAfterDelete()"
    >
    </app-embargo-delete-modal>
  </div>
</div>
